export default __webpack_public_path__ + "static/media/bike.007db1e5.svg";